// src/hooks/portfolio/usePortfolioHoldings.ts

import { useQuery } from "@tanstack/react-query";
import { portfolioHoldingsQueryOptions } from "@/services/queries/portfolioQueries";

export const usePortfolioHoldings = (authToken?: string) => {
  return useQuery(portfolioHoldingsQueryOptions(authToken));
};


